import { Design, WorkflowObject } from '../../../types';
import { getWfsPrompts } from './get-wfs-prompts';
import { getWfsFillerPrompts } from './get-wfs-filler-prompts';

export function getWfsObject(serialized: Design): WorkflowObject {
  const {
    applicationVersion,
    clientName,
    designName,
    languages
  } = serialized;
  return {
    activateSolid: true,
    application: `${clientName}${designName}`,
    client: clientName,
    languages: languages.map((language) => {
      const isTtsOnly = !language.voice;
      return {
        ...language,
        generateStaticTts: isTtsOnly,
        readyForActivation: isTtsOnly
      };
    }),
    prompts: [
      ...getWfsPrompts(serialized),
      ...getWfsFillerPrompts(serialized)
    ],
    version: applicationVersion
  };
}
